// frontend-react/src/pages/adReview/adReviewUtils.ts
// ✅ 純函式：不依賴 React / UI，可單獨測試

import type { ReviewItem, RiskLevel } from '../../types';

export type { RiskLevel };

export const getRiskLevel = (riskLevel?: string | null): RiskLevel => {
  if (riskLevel === 'high' || riskLevel === 'medium' || riskLevel === 'low') {
    return riskLevel;
  }
  // 歷史資料或 AI 未輸出時 → default（橘色，維持原本樣式）
  return 'default';
};

export const calculateRiskCounts = (results: ReviewItem[]) => {
  const counts: Record<'high' | 'medium' | 'low', number> = { high: 0, medium: 0, low: 0 };
  results.forEach(item => {
    const level = getRiskLevel(item.risk_level);
    if (level === 'high' || level === 'medium' || level === 'low') {
      counts[level]++;
    }
  });
  return counts;
};

export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const result = reader.result as string;
      const base64 = result.split(',')[1] || '';
      resolve(base64);
    };
    reader.onerror = () => reject(new Error('FileReader failed to read file'));
  });
};
